import React, { memo } from 'react';
import AdvisorSearch from './AdvisorSearch';

const AdditionalFields = ({ 
  formData, 
  handleInputChange, 
  errors, 
  isGroupLoan, 
  advisor,
  productoSeleccionado,
  apiBasePath = '/api/admin'
}) => {
  const frecuenciasBase = [
    { value: 'semanal', label: 'SEMANAL' },
    { value: 'catorcenal', label: 'CATORCENAL' },
    { value: 'mensual', label: 'MENSUAL' },
  ];

  const permiteDecenal = Array.isArray(productoSeleccionado?.frecuencias_permitidas)
    ? productoSeleccionado.frecuencias_permitidas.includes('decenal')
    : productoSeleccionado?.tipo_producto === 'CAMPANA' && productoSeleccionado?.activo !== false;

  const frecuenciasDisponibles = permiteDecenal
    ? [{ value: 'decenal', label: 'DECENAL' }]
    : frecuenciasBase;

  const handleAdvisorSelect = (advisor) => {
    const advisorId = advisor.idUsuario || `${advisor.datos?.nombre || ''} ${advisor.datos?.apellido || ''}`.trim();
    
    handleInputChange({
      target: {
        name: 'asesor',
        value: advisorId
      }
    });
    
    handleInputChange({
      target: {
        name: 'advisorData',
        value: advisor
      }
    });
  };

  const handleAdvisorRemove = () => {
    handleInputChange({
      target: {
        name: 'asesor',
        value: ''
      }
    });
    
    handleInputChange({
      target: {
        name: 'advisorData',
        value: null
      }
    });
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3 md:gap-4">
      {/* Frecuencia */}
      <div className="flex flex-col">
        <label className="mb-1 text-xs font-medium text-slate-700 sm:text-sm md:mb-2">FRECUENCIA</label>
        <select
          name="frecuencia"
          value={formData.frecuencia}
          onChange={handleInputChange}
          disabled={permiteDecenal}
          className={`w-full rounded-xl border bg-white px-3 py-2 text-sm text-slate-900 transition focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-600 ${errors.frecuencia ? 'border-red-500' : 'border-slate-300'}`}
        >
          <option value="">SELECCIONE...</option>
          {frecuenciasDisponibles.map(frecuencia => (
            <option key={frecuencia.value} value={frecuencia.value}>
              {frecuencia.label}
            </option>
          ))}
        </select>
        {errors.frecuencia && <p className="text-red-500 text-sm mt-1">{errors.frecuencia}</p>}
      </div>
     
      {/* Asesor */}
      {!isGroupLoan && (
        <div className="flex flex-col">
          <label className="mb-1 text-xs font-medium text-slate-700 sm:text-sm md:mb-2">ASESOR</label>
          <AdvisorSearch
            apiBasePath={apiBasePath}
            selectedAdvisor={formData.advisorData}
            onSelect={handleAdvisorSelect}
            onRemove={handleAdvisorRemove}
            errors={errors.asesor}
          />
        </div>
      )}
      
      {/* Modalidad */}
      <div className="flex flex-col">
        <label className="mb-1 text-xs font-medium text-slate-700 sm:text-sm md:mb-2">MODALIDAD</label>
        <select
          name="modalidad"
          value={formData.modalidad}
          onChange={handleInputChange}
          className={`w-full rounded-xl border bg-white px-3 py-2 text-sm text-slate-900 transition focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 ${errors.modalidad ? 'border-red-500' : 'border-slate-300'}`}
        >
          <option value="">SELECCIONE...</option>
          <option value="NUEVO">NUEVO</option>
          <option value="RCS">RCS</option>
          <option value="RSS">RSS</option>
          <option value="INACTIVO">INACTIVO</option>
        </select>
        {errors.modalidad && <p className="text-red-500 text-sm mt-1">{errors.modalidad}</p>}
      </div>
    </div>
  );
};

export default memo(AdditionalFields);
